export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-torsos-all-371b9f400c277276e6d6c68b49027eb6.svg";